import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { getWeddingPartyMemberRole } from './WeddingPartyMemberRoles';
import { getWeddingPartyMembers, editWeddingPartyMember } from '../../../../actions/website/entities/WeddingPartyMembersActions';
import { moveEntity, resetEntities, addEntity } from '../../../../actions/website/EntityActions';
import { showModal } from '../../../../actions/ModalActions';
import EntityHeader from './EntityHeader';
import DragHandle from '../../../common/ui/DragHandle';
import { togglePage } from '../../../../actions/website/PageActions';
import EditPageForm from './EditPageCommon/EditPageForm';
import EditPageHeader from './EditPageCommon/EditPageHeader';
import EditPageAddEntity from './EditPageCommon/EditPageAddEntity';
import { EntityName, EntityType } from './EditPageCommon/EditPageSortableList';
import featureFlag from '../../../../util/featureFlags';


const isCmsPageFormV2 = featureFlag.get('isCmsPageFormV2');
const PageHeader = isCmsPageFormV2 ? EditPageHeader : EntityHeader;

const MemberDetails = (entity) => {
  const member = entity || {};
  const {
    name,
    role,
    custom_role: customRole,
  } = member;
  const memberRole = role === 'CUSTOM' ? customRole : getWeddingPartyMemberRole(role);

  return (
    <>
      <EntityType type={memberRole} />
      <EntityName name={name} />
    </>
  )
}

class WeddingPartyMembers extends Component {
  componentDidMount() {
    const { getWeddingParty } = this.props;
    getWeddingParty();
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  render() {
    const { weddingPartyMembers, orderedIds, editMember, deleteMember, openModal, page, themeKey, onPageToggle } = this.props;
    const pageType = page && page.type;
    return (
      <div>
        {themeKey && <PageHeader page={page} onAdd={openModal} entityName="Person" themeKey={themeKey} onPageToggle={onPageToggle} />}
        {isCmsPageFormV2 ? (
          <>
            <EditPageForm page={page} />
            <EditPageAddEntity
              entityName="Person"
              pageType={pageType}
              orderedIds={orderedIds}
              entities={weddingPartyMembers}
              onAdd={openModal}
              onEdit={editMember}
              onDelete={deleteMember}
              entityDetail={MemberDetails}
            >
              <ul className="sortable-list">
                {weddingPartyMembers && orderedIds.map((memberId, index) => (
                  <WeddingPartyMember
                    key={memberId}
                    member={weddingPartyMembers[memberId]}
                    editMember={editMember}
                    deleteMember={deleteMember}
                    index={index}
                  />
                ))}
              </ul>
            </EditPageAddEntity>
          </>
        ) : (
          <ul className="sortable-list">
            {weddingPartyMembers && orderedIds.map((memberId, index) => (
              <WeddingPartyMember
                key={memberId}
                member={weddingPartyMembers[memberId]}
                editMember={editMember}
                deleteMember={deleteMember}
                index={index}
              />
            ))}
          </ul>
        )}
      </div>
    );
  }
}

WeddingPartyMembers.propTypes = {
  weddingPartyMembers: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getWeddingParty: PropTypes.func.isRequired,
  editMember: PropTypes.func.isRequired,
  deleteMember: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func
};

const mapStateToProps = state => (
  {
    weddingPartyMembers: state.website.entities.byId,
    orderedIds: state.website.entities.orderedIds,
    page: state.website.pages.byId[state.website.pages.typeToId.WEDDING_PARTY],
    themeKey: state.wedding.theme.key
  }
);

const mapDispatchToProps = dispatch => (
  {
    editMember: (member) => {
      dispatch(editWeddingPartyMember(member));
      dispatch(showModal('WEDDING_PARTY', { isUpdate: true }, { size: 'md' }));
    },
    deleteMember: (entity) => {
      dispatch(showModal('DELETE_ENTITY', { entity }));
    },
    getWeddingParty: () => {
      dispatch(getWeddingPartyMembers());
    },
    onSortEnd: ({ oldIndex, newIndex }) => {
      dispatch(moveEntity(oldIndex, newIndex));
    },
    openModal: () => {
      dispatch(addEntity());
      dispatch(showModal('WEDDING_PARTY', {}, { size: 'md' }));
    },
    unloadEntities: () => {
      dispatch(resetEntities());
    },
    onPageToggle: pageId => dispatch(togglePage(pageId))
  }
);

const WeddingPartyMember = SortableElement(({ member, editMember, deleteMember }) => {
  const noPropagate = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  return (
    <li className="sortable-item editable-entity" onClick={() => editMember(member)}>
      <div className="col-sm-1">
        <DragHandle tooltip="Drag to reorder" />
      </div>
      <div className="col-sm-8">
        <span className="type">
          {member.role === 'CUSTOM' ? member.custom_role : getWeddingPartyMemberRole(member.role)}
        </span>
        <span className="title-v2">
          {member.name}
        </span>
      </div>
      <div className="col-sm-3 entity-actions" onClick={noPropagate}>
        <button onClick={() => editMember(member)} title="Edit Person" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Edit"><i className="glyphicon glyphicon-pencil" /></button>
        <button onClick={() => deleteMember(member)} title="Delete Person" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Delete"><i className="glyphicon glyphicon-trash" /></button>
      </div>
    </li>
  );
});

WeddingPartyMember.propTypes = {
  member: PropTypes.shape({}).isRequired,
  editMember: PropTypes.func.isRequired,
  deleteMember: PropTypes.func.isRequired,
  index: PropTypes.number
};

const SortableWeddingPartyMembers = SortableContainer(WeddingPartyMembers);

const WeddingPartyMembersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SortableWeddingPartyMembers);

export default WeddingPartyMembersContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/WeddingPartyMembers.jsx